import styled from "styled-components";
import C from "@assets/themes/colors";

export const Root = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const ExplorerContainer = styled.div`
  max-height: 300px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
`;

export const ItemContainer = styled.div`
  width: 100px;
  height: 78px;
  margin: 12px 16px 50px 22px;
`;

export const ItemName = styled.span`
  width: 100%;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 10px;
  color: ${C.DARK_GRAY};
`;

export const FolderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FolderIconContainer = styled.div`
  cursor: pointer;
`;

export const AssetContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AssetImage = styled.img`
  width: 64px;
  height: 47px;
  border-radius: 5px;
  background-color: rgba(18, 36, 66, 0.3);
  object-fit: cover;
`;
